import { baseTheme } from "./baseTheme";
import { brandColor } from "./brand";

export const lightThemeConfig = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    bg: "#ffffff",
    fg: '#111928',       // Lion Energy gray-900
    card: "#ffffff",
    cardFg: '#1F2A37',   // Lion Energy gray-800
    border: '#D1D5DB',   // Lion Energy gray-300
    muted: '#F3F4F6',    // Lion Energy gray-100
    mutedFg: '#374151',  // Lion Energy gray-700
    /** Secondary body text, form labels, checkbox labels */
    fgSecondary: '#6B7280',
    /** Tertiary / footer / hint text */
    fgMuted: '#9CA3AF',
    /** Input placeholder text (more subdued than entered value) */
    placeholderFg: '#9CA3AF',
    /** Ghost & subtle control hover (visible on light surfaces) */
    interactiveHover: '#E5E7EB',
    /** Input fields on cards */
    fieldBg: '#ffffff',
    primary: '#FFCF51',  // Lion Energy yellow-500
    primaryFg: '#111928',
    /** Auth flow full-page background */
    surfaceAuth: '#faf9f5',
    /** Authenticated app main content area */
    surfaceSubtle: '#F9FAFB',
  },
};
